var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 7.3335V11.3335C14.3333 14.0002 13.6667 14.6668 11 14.6668H4.33333C1.66667 14.6668 1 14.0002 1 11.3335V4.66683C1 2.00016 1.66667 1.3335 4.33333 1.3335H5.33333C6.33333 1.3335 6.55333 1.62683 6.93333 2.1335L7.93333 3.46683C8.18667 3.80016 8.33333 4.00016 9 4.00016H11C13.6667 4.00016 14.3333 4.66683 14.3333 7.3335Z",
    stroke: "#787486",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 1.3335H11.3335C12.6668 1.3335 13.3335 2.00016 13.3335 3.3335V4.2535",
    stroke: "#787486",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 10H6",
    stroke: "#787486",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.37d6698f031c30cea7248119f16dea66.svg";
export { ForwardRef as ReactComponent };